import * as yup from 'yup'

export const completeDriverLicenseFormValidator = yup.object({
  file: yup
    .mixed<File>()
    .nullable()
    .test('required', 'Attach the driver license', (value) => {
      return Boolean(value)
    }),
  // The DTO marks it optional, but the service answers 400 "ExpiresAt is required for this step".
  expiresAt: yup.string().trim().required('Choose the expiration date'),
})
